import findTicketDetailByIdUseCase from "./findTicketDetailByIdUseCase"
import updateTicketDetailUseCase from "./updateTicketDetailUseCase"

const { default: findTaskByReferenceUseCase } = require("tasks/services/sign/findTaskByReferenceUseCase")

const addTaskToTicketDetail = async (ticket, ivaPercent, taskReference) => {
    const invoiceDetail = await findTicketDetailByIdUseCase(ticket.id)
    const { deviceName, description, budget } = await findTaskByReferenceUseCase(taskReference)
    
    const item = {
        reference: taskReference || "",
        description: `${deviceName} - ${description}` || "",
        unitPrice: budget || 0,
        units: 1
    }

    invoiceDetail.data.push(item)

    return updateTicketDetailUseCase(ticket, ivaPercent, invoiceDetail)
}

export default addTaskToTicketDetail